import React from "react";
import "../PrintAudit.style.css";
// import logoImg from "../../../assets/images/WorkPermitFullLogo.svg";
import { Typography } from "@mui/material";

const HeaderSection = ({ CompanyInfo }) => {
  const { logo, name } = CompanyInfo;
  // console.log("CompanyInfo: ", CompanyInfo);
  return (
    <div className="print-wp-header-div">
      <div>
      <Typography className="inter-medium-500" variant="h5">
        {name} | Audit Details
      </Typography>
      </div>
      <div>
        <div
          style={{
            width: "70px",
            height: "70px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt="Company Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain", // Ensures the image fills the box properly
              objectPosition: "center",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
